module.exports = __webpack_public_path__ + "static/media/cancel-icon.e8b3d953.svg";